<template>
	<EditableTextField ref="name" :text="text" class="editable-text-field text-overflow-ellipsis" />
</template>

<script>
import EditableTextField from '@/components/common/EditableTextField';
export default {
	name: 'ApiDocsEditableTextField',
	components: { EditableTextField },
	props: { text: { type: String }, id: { type: [String, Number] } },
};
</script>

<style scoped lang="scss">
.editable-text-field {
	&::v-deep {
		&.v-text-field {
			> .v-input__control > .v-input__slot {
				height: 17px;
				font-weight: 600;
				font-size: 12px !important;
				color: var(--primary-font-color);
				&:before {
					border: none;
				}

				&:after {
					border-width: 1px !important;
					border-color: var(--primary-color);
				}
			}

			&.v-input--is-disabled,
			&.v-input--is-disabled input {
				opacity: 1 !important;
				color: #3e495a !important;
			}
		}
	}
}
</style>
